<script setup>
import { ref } from 'vue';

const emit = defineEmits(['close']);
const activeTab = ref('recent');

const tabs = [
  { id: 'recent', name: 'Recent' },
  { id: 'favorites', name: 'Favorites' },
  { id: 'liked', name: 'Liked' }
];

const closeModal = () => {
  emit('close');
};
</script>

<template>
  <div class="modal-overlay" @click="closeModal">
    <div class="modal-content" @click.stop>
      <div class="modal-header">
        <h2 style="color: #fff;">My games</h2>
        <button class="close-button" @click="closeModal">
          <i class="bi bi-x-lg"></i>
        </button>
      </div>

      <div class="tabs">
        <button v-for="tab in tabs" :key="tab.id" :class="['tab-button', { active: activeTab === tab.id }]"
          @click="activeTab = tab.id">
          {{ tab.name }}
        </button>
      </div>

      <div class="modal-body">
        <div v-if="activeTab === 'recent'" class="empty-state">
          <div class="empty-icon">
            <i class="bi bi-clock"></i>
          </div>
          <p>All your recently played games will be listed here. Have some fun!</p>
        </div>

        <div v-if="activeTab === 'favorites'" class="empty-state">
          <div class="empty-icon">
            <i class="bi bi-heart"></i>
          </div>
          <p>Your favorite games will appear here</p>
        </div>

        <div v-if="activeTab === 'liked'" class="empty-state">
          <div class="empty-icon">
            <i class="bi bi-hand-thumbs-up"></i>
          </div>
          <p>Games you've liked will be shown here</p>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1050;
  backdrop-filter: blur(4px);
}

.modal-content {
  background-color: #1a1b26;
  border-radius: 12px;
  width: 100%;
  max-width: 480px;
  max-height: 90vh;
  overflow-y: auto;
  position: relative;
}

.modal-header {
  padding: 1rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.modal-header h2 {
  font-size: 1.25rem;
  font-weight: 600;
  margin: 0;
}

.close-button {
  background: transparent;
  border: none;
  color: #e5e7eb;
  padding: 0.5rem;
  cursor: pointer;
  font-size: 1.25rem;
}

.close-button:hover {
  color: #7e3af2;
}

.tabs {
  display: flex;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  padding: 0 1rem;
}

.tab-button {
  background: transparent;
  border: none;
  color: #718096;
  padding: 1rem;
  cursor: pointer;
  font-weight: 500;
  position: relative;
}

.tab-button.active {
  color: #7e3af2;
}

.tab-button.active::after {
  content: '';
  position: absolute;
  bottom: -1px;
  left: 0;
  right: 0;
  height: 2px;
  background-color: #7e3af2;
}

.tab-button:hover {
  color: #7e3af2;
}

.modal-body {
  padding: 2rem;
}

.empty-state {
  text-align: center;
  color: #718096;
  padding: 2rem 1rem;
}

.empty-icon {
  font-size: 3rem;
  color: #2d3748;
  margin-bottom: 1rem;
}

@media (max-width: 768px) {
  .modal-content {
    max-width: none;
    margin: 1rem;
  }
}
</style>